import React from 'react';

function Experience() {
    const experiences = [
        {
            role: "Software Engineer / Technical Lead",
            company: "Jobspri Solutions | India",
            duration: "Jul 2025 – Present",
            description: "Leading IT consulting and software delivery practice. Driving technical strategy, execution, and designing scalable system architectures for client platforms."
        },
        {
            role: "Full Stack Developer",
            company: "SoftEng IT | Remote",
            duration: "Sept 2023 – Jun 2025",
            description: "Built backend APIs using Django/DRF, implemented payment integrations, Celery/Redis background tasks, and managed AWS deployments (Nginx, Gunicorn)."
        },
        {
            role: "Full Stack Developer",
            company: "Jobspri | India",
            duration: "Aug 2021 – Aug 2023",
            description: "Developed job search and recruitment platforms, resume builders, and secure REST APIs. Optimized PostgreSQL/MySQL queries for performance."
        }
    ];

    return (
        <div className="rn-resume-area rn-section-gap section-separator" id="resume">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span className="subtitle">4+ Years of Quality Experience</span>
                            <h2 className="title">My Resume</h2>
                        </div>
                    </div>
                </div>
                <div className="row mt--45">
                    <div className="col-lg-12">
                        <div className="rn-nav-tabs-wrapper">
                            <div className="tab-content">
                                <div className="tab-pane fade show active">
                                    <div className="personal-experience-inner">
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="content">
                                                    <span className="subtitle">2021 - Present</span>
                                                    <h4 className="maintitle">Job Experience</h4>
                                                    <div className="experience-list">
                                                        {experiences.map((exp, index) => (
                                                            <div key={index} className="resume-single-list">
                                                                <div className="inner">
                                                                    <div className="heading">
                                                                        <div className="title">
                                                                            <h4>{exp.role}</h4>
                                                                            <span>{exp.company}</span>
                                                                        </div>
                                                                        <div className="date-of-time">
                                                                            <span>{exp.duration}</span>
                                                                        </div>
                                                                    </div>
                                                                    <p className="description">{exp.description}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Experience;
